import './CursuriPresentation.css';
import { Link } from 'react-router-dom';
import bazeleconta from '../imagesHome/bazeleconta.png';
import contafinanciara from '../imagesHome/contafinanciara.png';
import progresscard from '../imagesHome/progress-card.png';

const CursuriPresentation = () => {
  return (
    <main className="courses-page">
      <section className="courses-hero">
        <div className="courses-container courses-hero-grid">
          <div>
            <p className="courses-kicker">Cursurile ContaLearn</p>
            <h1 className="courses-title">Invata contabilitate pas cu pas, intr-un format clar si practic</h1>
            <p className="courses-subtitle">
              Toate cursurile sunt create pentru incepatori si structurate progresiv, ca sa stii exact ce inveti si cum aplici.
            </p>
            <div className="courses-hero-actions">
              <Link to="/quiz-start" className="courses-btn courses-btn-primary">Incepe acum</Link>
              <Link to="/home" className="courses-btn courses-btn-outline">Inapoi la pagina principala</Link>
            </div>
          </div>
          <div className="courses-highlight-card">
            <h3>Ce primesti in platforma</h3>
            <div className="courses-highlight-grid">
              <div className="courses-highlight-item">
                <strong>300+</strong>
                <span>lectii interactive</span>
              </div>
              <div className="courses-highlight-item">
                <strong>2</strong>
                <span>cursuri mari, complete</span>
              </div>
              <div className="courses-highlight-item">
                <strong>100%</strong>
                <span>acces online din browser</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="courses-list-wrap">
        <div className="courses-container">
          <div className="courses-heading">
            <h2>Alege traseul potrivit pentru tine</h2>
            <p>Fiecare curs include lectii teoretice, exemple aplicate si verificari de progres.</p>
          </div>

          <div className="courses-grid">
            <article className="course-card">
              <div className="course-badge">Incepator</div>
              <img src={bazeleconta} alt="Bazele contabilitatii" className="course-image" />
              <h3>Bazele contabilitatii</h3>
              <p>Ideal daca incepi de la zero: inveti conceptele esentiale, conturile si logica inregistrarilor contabile.</p>
              <ul>
                <li>Partida dubla explicata simplu</li>
                <li>Conturi de baza si exemple reale</li>
                <li>Exercitii rapide dupa fiecare capitol</li>
              </ul>
              <Link to="/bazeleconta" className="courses-btn courses-btn-primary">Incepe cursul</Link>
            </article>

            <article className="course-card">
              <div className="course-badge course-badge-alt">Intermediar</div>
              <img src={contafinanciara} alt="Contabilitate financiara" className="course-image" />
              <h3>Contabilitate financiara</h3>
              <p>Aprofundezi raportarea financiara, inchiderea de luna si elemente utile pentru practica profesionala.</p>
              <ul>
                <li>Situatii financiare pe intelesul tau</li>
                <li>Monografii si scenarii aplicate</li>
                <li>Recapitulare orientata pe examene</li>
              </ul>
              <Link to="/contafinanciara" className="courses-btn courses-btn-primary">Incepe cursul</Link>
            </article>

            <article className="course-card">
              <div className="course-badge course-badge-certificate">Bonus</div>
              <img src={progresscard} alt="Progres si certificare" className="course-image" />
              <h3>Progres si certificare</h3>
              <p>Urmaresti progresul pe parcurs si obtii certificare la finalul traseului de invatare.</p>
              <ul>
                <li>Urmarire progres pe module</li>
                <li>Structura clara a lectiilor</li>
                <li>Certificat digital la final</li>
              </ul>
              <Link to="/quiz-start" className="courses-btn courses-btn-primary">Creeaza cont</Link>
            </article>
          </div>
        </div>
      </section>

      <section className="courses-cta-strip">
        <div className="courses-container courses-cta-inner">
          <div>
            <h2>Gata sa incepi?</h2>
            <p>Fa primul pas si intra in platforma pentru a vedea toate lectiile disponibile.</p>
          </div>
          <Link to="/quiz-start" className="courses-btn courses-btn-primary">Vezi toate cursurile in platforma</Link>
        </div>
      </section>
    </main>
  );
};

export default CursuriPresentation;
